import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ApplicationStore } from '../../_stores/ApplicationStore';
// import { LoginBackground, TightKnitLogoWhite } from '../../images/images';

import Modal from '../../_components/FormComponents/Modal';
import AuthPage from './AuthPage';
import ForgotPasswordForm from './ForgotPasswordForm';

interface ICredentials {
    email: string,
    password: string
}

interface IServerErrorWarning {
    friendlyMessage: string,
    message: string
}

interface IState {
    credentials: ICredentials;
    serverErrorWarning?: IServerErrorWarning;
    isSendingForgotPasswordEmail: boolean;
    showSuccessModal: boolean;
}

interface IProps {
    store: ApplicationStore;
}

@inject('store')
@observer
export class ForgotPasswordPage extends React.Component<IProps & RouteComponentProps<any>, IState> {
    private _loginListenerDisposer = () => { return; };

    public state: IState = {
        credentials: {
            email: '',
            password: ''
        },
        isSendingForgotPasswordEmail: false,
        showSuccessModal: false
    };

    public componentDidMount(): void {
        // Set the email address if it was provided on the login page
        if (this.props.location.state && this.props.location.state.credentials) {
            this.setState({credentials: this.props.location.state.credentials});
        }
    }

    public componentWillUnmount(): void {
        this._loginListenerDisposer();
    }

    public finish = () => {
        this.setState({showSuccessModal: false});
    }

    public handleSubmit = (isValid: boolean) => {
        if (isValid) {
            this.setState({isSendingForgotPasswordEmail: true});
            this.props.store.passwordResetStore.resetPassword(this.state.credentials.email)
                .then((res) => {
                    this.setState({isSendingForgotPasswordEmail: false});
                    this.setState({ showSuccessModal: true });
                })
                .catch((err) => {
                    let serverErrorWarning = {
                        friendlyMessage: 'That did not work',
                        message: 'unknown-error'
                    };
                    this.setState({serverErrorWarning});
                });
        }
    }

    private setCredentials = (credentials: ICredentials) => {
        this.setState({credentials});
    }

    public render() {

        const renderHelpText = () => (
            <div className="auth-page__help-text">
                <p>
                    Enter the email address you used to sign up for TightKnit and click “submit.” You will receive an email containing a link for resetting your password.
                </p>
                <p>
                    If you have any questions or problems logging into your TightKnit account, please contact us
                    at <a href="mailto:support@tightknit.com">support@tightknit.com</a>.
                </p>


            </div>
        );

        return (

            <AuthPage>
                <h1 className="auth-page__card__header">Forgot your password?</h1>
                <ForgotPasswordForm
                    credentials={this.state.credentials}
                    error={this.state.serverErrorWarning}
                    handleSubmit={this.handleSubmit}
                    isLoggingIn={false}
                    setCredentials={this.setCredentials}
                    isSendingForgotPasswordEmail={this.state.isSendingForgotPasswordEmail}
                    renderHelpText={renderHelpText}
                />
                <Modal confirmButtonOnClick={this.finish}
                       confirmButtonText="OK"
                       declineButtonOnClick={this.finish}
                       show={this.state.showSuccessModal}
                       title="Success!">
                    Check your email inbox for instructions on how to reset your password.
                </Modal>
            </AuthPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/ForgotPasswordPage.tsx